var _g, _g2, _g3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar07(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_675_1851)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2386 6.60667L8.8986 3.26978C8.84428 3.1345 8.79509 3.01221 8.75013 2.90135C8.70516 3.01221 8.65597 3.1345 8.60165 3.26978L7.26165 6.60667L3.674 6.84993C3.52855 6.85979 3.39704 6.86878 3.27772 6.87729C3.36926 6.95431 3.47036 7.03888 3.58223 7.13234L6.34172 9.43792L5.46443 12.9251C5.42886 13.0665 5.39678 13.1944 5.36799 13.3105C5.46953 13.2472 5.58121 13.1772 5.70467 13.0997L8.75013 11.1877L11.7956 13.0997C11.919 13.1772 12.0307 13.2472 12.1323 13.3105C12.1035 13.1944 12.0714 13.0665 12.0358 12.9251L11.1585 9.43792L13.918 7.13235C14.0299 7.03888 14.131 6.95431 14.2225 6.87729C14.1032 6.86878 13.9717 6.85979 13.8263 6.84993L10.2386 6.60667ZM6.33629 5.33302L3.5838 5.51965C2.42493 5.59823 1.84549 5.63752 1.59851 5.88236C1.38431 6.09471 1.28594 6.39749 1.33441 6.69518C1.3903 7.03844 1.83598 7.41081 2.72734 8.15554L4.84445 9.92441L4.17138 12.5999C3.88801 13.7263 3.74632 14.2895 3.90286 14.6001C4.03863 14.8694 4.29618 15.0565 4.59429 15.1024C4.93801 15.1553 5.42988 14.8465 6.41361 14.2289L8.75013 12.762L11.0866 14.2289C12.0704 14.8465 12.5622 15.1553 12.906 15.1024C13.2041 15.0565 13.4616 14.8694 13.5974 14.6001C13.7539 14.2895 13.6122 13.7263 13.3289 12.5999L12.6558 9.92441L14.7729 8.15554C15.6643 7.41081 16.1099 7.03844 16.1658 6.69518C16.2143 6.39749 16.1159 6.09471 15.9017 5.88236C15.6548 5.63752 15.0753 5.59823 13.9165 5.51965L11.164 5.33302L10.1359 2.77291C9.70306 1.69505 9.48664 1.15611 9.17745 0.996883C8.9093 0.858787 8.59095 0.858787 8.3228 0.996883C8.01362 1.15611 7.79719 1.69505 7.36435 2.77292L6.33629 5.33302Z",
    fill: "#FF8833"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_675_1851",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 16
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_675_1851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.36435 2.77292C7.79719 1.69505 8.01362 1.15611 8.3228 0.996883C8.59095 0.858787 8.9093 0.858787 9.17745 0.996882C9.48664 1.15611 9.70306 1.69505 10.1359 2.77291L11.164 5.33302L13.9165 5.51965C15.0753 5.59823 15.6548 5.63752 15.9017 5.88236C16.1159 6.09471 16.2143 6.39749 16.1658 6.69518C16.1099 7.03844 15.6643 7.41081 14.7729 8.15555L12.6558 9.92441L13.3289 12.5999C13.6122 13.7263 13.7539 14.2895 13.5974 14.6001C13.4616 14.8694 13.2041 15.0565 12.906 15.1024C12.5622 15.1553 12.0704 14.8465 11.0866 14.2289L8.75013 12.762L6.41361 14.2289C5.42988 14.8465 4.93801 15.1553 4.59429 15.1024C4.29618 15.0565 4.03863 14.8694 3.90286 14.6001C3.74632 14.2895 3.88801 13.7263 4.17139 12.5999L4.84445 9.92441L2.72734 8.15555C1.83598 7.41081 1.3903 7.03844 1.33441 6.69518C1.28594 6.39749 1.38431 6.09471 1.59851 5.88236C1.84549 5.63752 2.42493 5.59823 3.5838 5.51965L6.33629 5.33302L7.36435 2.77292Z",
    fill: "#FF8833"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_675_1851)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    width: 9.5,
    height: 16,
    fill: "#FF8833"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_675_1851"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.75)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_675_1851"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar07);
export default __webpack_public_path__ + "static/media/star-0.7.0a8edf6c30a0284d7feb6791480cff9d.svg";
export { ForwardRef as ReactComponent };